<template>
  <div class="login-container">
    <div class="login-fields">
      <div class="home-backsplash-mobile is-hidden-tablet"></div>
      <div class="is-hidden-mobile home-backsplash-desktop"></div>
      <h1>Coming Soon</h1>
      <h4>
        The functionality for your login on the new Mission Control is not yet
        available.
      </h4>
      <div>
        Please email alix@reflectivelearning.co.za for more information.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
  data() {}
};
</script>
